export default {"src":"/_next/static/media/Icon_POI_unselected_m.4ab1e847.svg","height":40,"width":32};